module.exports = __webpack_public_path__ + "img/exofive_packs.topps.beccd21.png";